<div *ngIf="contacts()?.length > 0" class="association">
  <div class="subtitle">{{ 'ACTIVITY.POPOVER.CONTACTS' | translate }}</div>
  <div *ngFor="let contact of contacts()">
    <a [routerLink]="routePrefix() + '/' + contact.linkUrl">
      {{ contact.name }}
    </a>
  </div>
</div>
<div *ngIf="companies()?.length > 0" class="association">
  <div class="subtitle">{{ 'ACTIVITY.POPOVER.COMPANIES' | translate }}</div>
  <div *ngFor="let company of companies()">
    <a [routerLink]="routePrefix() + '/' + company.linkUrl">
      {{ company.name }}
    </a>
  </div>
</div>
<div *ngIf="opportunities()?.length > 0" class="association">
  <div class="subtitle">{{ 'ACTIVITY.POPOVER.OPPORTUNITIES' | translate }}</div>
  <div *ngFor="let opportunity of opportunities()">
    {{ opportunity.name }}
  </div>
</div>
<div *ngIf="teamMembers()?.length > 0" class="association">
  <div class="subtitle">{{ 'ACTIVITY.POPOVER.TEAM_MEMBERS' | translate }}</div>
  <div *ngFor="let member of teamMembers()">
    {{ member.name }}
  </div>
</div>
